export const BASE_URL = "https://api.glamiraa.in";
export const IMG_URL  = "https://glamiraa.in";
// export const BASE_URL = "http://localhost:8083";
// export const IMG_URL  = "http://localhost:8083";